<template>
  <div :id="'category' + p_category.intCategoryId" class="container">
    <template v-if="c_get_candys">
      <template v-for="(candy, index) in c_get_candys">
        <div v-if="(index % 2) == 0" class="row">
          <div class="col-xs-12 col-sm-6">
            <v-candyticket :key="index" :p_candy="candy"></v-candyticket>
          </div>
          <div class="col-xs-12 col-sm-6" v-if="c_get_candys[index + 1]">
            <v-candyticket :key="index + 1" :p_candy="c_get_candys[index + 1]"></v-candyticket>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import $ from "jquery";
import CandyTicket from "./CandyTicket.vue";

export default {
  name: "candycategory",
  components: {
    "v-candyticket": CandyTicket
  },
  props: {
    p_category: { type: Object, default: () => null }
  },
  computed: {
    c_get_candys: function () {
      return this.p_category.Candys;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CandyCategory.vue